import { render, staticRenderFns } from "./WelcomeFriendsModal.vue?vue&type=template&id=4aa6de64&scoped=true&"
import script from "./WelcomeFriendsModal.vue?vue&type=script&lang=js&"
export * from "./WelcomeFriendsModal.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeFriendsModal.vue?vue&type=style&index=0&id=4aa6de64&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa6de64",
  null
  
)

export default component.exports